import { defineComponent as _defineComponent } from 'vue'
import ToggleableField from "@/components/plant/ToggleableField.vue"


const __default__ = {
  name: "RowField"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: String,
    default: '',
    required: true
  },
  label: String,
  edit: {
    type: Boolean,
    required: false,
    default: false
  },
  multiLine: {
    type: Boolean,
    default: false
  },
  rows: {
    type: Number,
    default: 4,
  }
},
  emits: ['update:modelValue'],
  setup(__props, { expose }) {
  expose();





const __returned__ = { ToggleableField }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})